import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "logout-prompt"
  }, [_c('div', {
    staticClass: "logout-prompt-content"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.t('确认注销')))]), _c('div', {
    staticClass: "mb-10"
  }, [_vm._v(_vm._s(_vm.t('请确认您已经准备放弃该客户代码（{0}）', [_vm.userInfo.customer_code])))]), _c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.t('客户代码注销以后以下信息将被清空且无法找回')))]), _c('ol', [_c('li', [_vm._v(_vm._s(_vm.t('用户认证信息')))]), _c('li', [_vm._v(_vm._s(_vm.t('交易记录')))]), _c('li', [_vm._v(_vm._s(_vm.t('历史订单信息')))])])]), _c('div', {
    staticClass: "logout-prompt-btn",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticClass: "mr-20",
    attrs: {
      "data-permission": "customer_logout_account_previous",
      "id": "customer_logout_account_previous",
      "fbu-analyse-name": $t("\u4E0A\u4E00\u6B65")
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(_vm._s(_vm.t('上一步')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "customer_logout_account_logout",
      "id": "customer_logout_account_logout",
      "fbu-analyse-name": $t("\u7ACB\u5373\u6CE8\u9500")
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v(_vm._s(_vm.t('立即注销')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };